import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=e550cf3c&scoped=true"
import script from "./freight.vue?vue&type=script&lang=js"
export * from "./freight.vue?vue&type=script&lang=js"
import style0 from "./freight.vue?vue&type=style&index=0&id=e550cf3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e550cf3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e550cf3c')) {
      api.createRecord('e550cf3c', component.options)
    } else {
      api.reload('e550cf3c', component.options)
    }
    module.hot.accept("./freight.vue?vue&type=template&id=e550cf3c&scoped=true", function () {
      api.rerender('e550cf3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/storeSettleIn/components/freight.vue"
export default component.exports